"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserCurrentStateResponseMapper = void 0;
var UserCurrentStateResponseMapper = /** @class */ (function () {
    function UserCurrentStateResponseMapper(data) {
        this.localData = data;
    }
    UserCurrentStateResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return UserCurrentStateResponseMapper;
}());
exports.UserCurrentStateResponseMapper = UserCurrentStateResponseMapper;
//# sourceMappingURL=UserCurrentStateResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/models/mappers/UserCurrentStateResponseMapper.js
// module id = 1452
// module chunks = 8